import { clsx } from "clsx";
import { Link } from "react-router";

type INavLink = {
  text: string;
  url: string;
  children?: INavLink[];
};

type IProps = {
  link: INavLink;
  onDismiss: () => void;
};

export const MobileLink = ({ link, onDismiss }: IProps) => {
  return (
    <Link
      className={clsx("mobile-menu__link nuco-typography--headline")}
      to={link.url}
      onClick={onDismiss}
    >
      {link.text}
    </Link>
  );
};
